export default {
  img: {
    once: true,
    offset: [100, 100]
  },
  productImageCard: {
    once: true,
    offset: [100, 100]
  }
};
